import { addDaysToDateString as e } from "@maat/datetime";
//#region src/properties/roomPicker/roomsLeft.ts
var t = (t, n) => {
	if (!t.start || !t.end || t.start >= t.end) return null;
	let r = null;
	for (let i = t.start; i < t.end; i = e(i, 1)) {
		let e = n[i];
		if (e === void 0) return null;
		r = r === null ? e : Math.min(r, e);
	}
	return r;
};
//#endregion
export { t as stayRoomsLeft };
